export class Timer {
	public tick(time:number){
		this._delta = (time - this._time) * 0.001;
		this._time = time;
	}
	public getTime():number{ return this._time; }
	public getDelta():number{ return this._delta; }
	private _time:number = 0;
	private _delta:number = 0;
}